/** ArtNotes — Discovery Reward 用、ピックアップ時に表示する美術運動小ネタ辞書。
 *  Reference: docs/GDD.md §1.2 Discovery Reward / CLAUDE.md §3.4
 *  Phase A 暫定:Lv1-10 のルネサンス章用 5 件。Phase B でローカライズ。
 */

export const ART_NOTES: Record<string, string> = {
  renaissance_01:
    'ルネサンスのフレスコ画家は、漆喰が乾く前の数時間で全色を塗り終えなければならなかった。',
  renaissance_02:
    'ティツィアーノは晩年、絵筆を投げ捨て指で塗ったという。彼の指紋が画面に残る。',
  renaissance_03: '黄金比 1:1.618 は、画面の中の「居心地のよい場所」と呼ばれた。',
  renaissance_04:
    '青色顔料(ラピスラズリ)は金より高価で、聖母マリアの衣にのみ使われた。',
  renaissance_05: 'カンバスは元々、船の帆だった。重い壁画から軽い旅する絵画へ。',
};

/** note_id から ArtNote テキストを取得。未定義キーは '...' を返す。 */
export function getArtNote(noteId: string): string {
  return ART_NOTES[noteId] ?? '...';
}
